<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <a class="decoration">Rental</a>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Rental Invoice Manage
      </h6>
      <div style="padding-bottom: 120px;" class="container-fluid">
        <div style="border: 0; padding: 0; min-height: 0;" class="navbar background_color">
          <div class="d-flex flex-column flex-md-row flex-wrap gap-2">
            <b-input-group size="sm" class="w-100" style="max-width: 225px;">
              <b-form-input v-model="filter" @input="currentPage = 1" type="search" placeholder="Search" />
            </b-input-group>

            <div class="ms-md-2 mt-2 mt-md-0">
              <span class="custom-breadcrumb d-block text-center text-md-start">
                <b>Showing {{ rangeStart }} - {{ rangeEnd }} of {{ filteredCount }} items.</b>
              </span>
            </div>
          </div>

          <div class="d-grid gap-2 d-md-flex justify-content-md-end">
            <button @click="createInvoice()" class="btn btn-outline-primary btn-sm mb-1 mt-1 bdr-rad">
              Create Rental Invoice
            </button>
          </div>
        </div>

        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <div class="d-flex justify-content-center" v-if="isLoading">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>

            <div v-else class="table-responsive">
              <b-table
                responsive
                style="font-size: small;"
                class="table-hover"
                :items="filteredRows"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                show-empty
                small
              >
                <template #cell(number)="row">
                  {{ (currentPage - 1) * perPage + row.index + 1 }}
                </template>

                <template #cell(total_invoice_amt)="row">
                  {{ formatMoney(row.item.total_invoice_amt) }}
                </template>

                <template #cell(actions)="row">
                  <div class="dropdown">
                    <button class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad" type="button" data-toggle="dropdown" aria-expanded="false">
                      Action
                    </button>
                    <div class="dropdown-menu bdr-rad">
                      <a class="dropdown-item mouse-cursor" @click="editRow(row.item.id)">Open</a>
                    </div>
                  </div>
                </template>
              </b-table>

              <b-col style="padding-left: 0;" sm="7" md="2" class="my-1 mb-4">
                <b-pagination v-model="currentPage" pills :total-rows="filteredCount" :per-page="perPage" size="sm" @input="currentPage = $event" />
              </b-col>
            </div>
          </div>
        </div>
      </div>
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from 'axios';
import authService from '@/auth.service';
import TopNavbar from './../../layout/TopNavbar.vue';
import ContentFooter from './../../layout/ContentFooter.vue';

export default {
  name: 'RentalInvoiceIndex',
  components: { TopNavbar, ContentFooter },
  data() {
    return {
      access_token: authService.isLoggedIn(),
      filter: "",
      rows: [],
      currentPage: 1,
      perPage: 15,
      totalRows: 0,
      isLoading: true,
      fields: [
        { key: "number", label: "#", sortable: true, sortDirection: "desc" },
        { key: "issue_no", label: "Invoice No", sortable: true },
        { key: "issue_date", label: "Issue Date", sortable: true },
        { key: "invoice_date", label: "Invoice Date", sortable: true },
        { key: "customer_name", label: "Customer", sortable: true },
        { key: "sales_person_name", label: "Sales Person", sortable: true },
        { key: "total_invoice_amt", label: "Invoice Total Amount", sortable: true, class: "text_right" },
        { key: "status", label: "Status", sortable: true },
        { key: "actions", label: "Actions", class: "width-custom7" },
      ],
    };
  },
  computed: {
    filteredRows() {
      const term = (this.filter || "").toLowerCase().trim();
      if (!term) {
        return this.rows;
      }

      return this.rows.filter((row) => {
        const values = [
          row.issue_no,
          row.issue_date,
          row.invoice_date,
          row.customer_name,
          row.sales_person_name,
          row.status,
          this.formatMoney(row.total_invoice_amt),
        ];

        return values.some((value) => String(value || "").toLowerCase().includes(term));
      });
    },
    filteredCount() {
      return this.filteredRows.length;
    },
    rangeStart() {
      if (!this.filteredCount) {
        return 0;
      }

      return (this.currentPage - 1) * this.perPage + 1;
    },
    rangeEnd() {
      return Math.min(this.currentPage * this.perPage, this.filteredCount);
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    formatMoney(value) {
      const num = Number(value || 0);
      return num.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    async loadData() {
      this.isLoading = true;
      try {
        const { data } = await axios.get('/rentalinvoice/index', {
          headers: { Authorization: 'Bearer ' + this.access_token, 'Content-type': 'application/json' },
        });
        this.rows = data.all_data || [];
        this.totalRows = this.rows.length;
      } catch (error) {
        console.log(error.response || error);
        this.rows = [];
        this.totalRows = 0;
      } finally {
        this.isLoading = false;
      }
    },
    editRow(id) {
      this.$router.push('/sinvoice/createrentalinvoice?id=' + id);
    },
    createInvoice() {
      this.$router.push('/sinvoice/createrentalinvoice');
    },
  },
};
</script>


<style scoped>
  .rental-invoice-table-head th {
    color: #fff;
  }
</style>
